export { default } from './DialogContent';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/DialogContent/index.js
// module id = 234
// module chunks = 2